import { createContext } from 'react'
import { AlertState } from '../hooks/useAlert'
import { CommonValueType } from './types'

export const CommonContext = createContext<
    CommonValueType & AlertState // FIXME Partial<CommonValueType>
>({} as any)